import * as React from 'react';
import eaiws = egr.wcf.eaiws;

interface CatalogLabelProps {
    catalog: eaiws.catalog.CatalogItem;
    catalogName: string;
    label: string;
}

interface CatalogLabelState {
    longCatalog: boolean;
}

export class CatalogLabel extends React.Component<CatalogLabelProps, CatalogLabelState> {
    protected catalogDiv: HTMLDivElement | null;
    public componentDidMount(): void {
        this.setState({
            longCatalog: this.catalogDiv != null && this.catalogDiv.clientHeight > 35
        });
    }

    public render(): JSX.Element {
        const styleFix: React.CSSProperties = {};
        /*
            This label should be shown as two lines with ellipsis at the end. This can be done with css;
            "display: -webkit-box; -webkit-line-clamp: 2;". But this solution will not work if first line has
            no spaces. So I disabled this solution if label begins with more then 14 letters, and fallback
            to "normal" css ellisis in one-line.
        */
        if (this.props.label && (this.props.label.indexOf(' ') === -1 || this.props.label.indexOf(' ') > 14)) {
            styleFix.display = 'block';
            styleFix.textOverflow = 'ellipsis';
        }
        return (
            <div className="catalog-item-label">
                {
                    this.props.catalog ?
                        <div className="catalog-item-catalog" ref={(node) => { this.catalogDiv = node; }}>{this.props.catalogName}</div> :
                        null
                }
                <div
                    className={
                        'catalog-item-name' +
                        ((this.state != null && this.state.longCatalog) ? ' catalog-item-name-nospace' : '')
                    }
                    style={styleFix}
                >
                    {this.props.label}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/catalog/CatalogLabel.tsx